/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { createContext, useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';

var Context = /*#__PURE__*/createContext();
Context.displayName = 'AccountContext';
var Provider = function Provider(_ref) {
  var mock = _ref.mock,
    mockObject = _ref.mockObject,
    children = _ref.children;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    account = _useState2[0],
    setAccount = _useState2[1];
  useEffect(function () {
    if (typeof window === 'undefined') {
      return undefined;
    }
    if (mock) {
      setAccount(mockObject || {
        profilePhoto: '',
        hasCFOrgs: true,
        accounts: [{
          status: 'ACTIVE',
          type: 'TRIAL',
          accountGuid: '123',
          accountName: "PAL's Account",
          isAccountOwner: true,
          owner: '12345',
          iamOwnerId: 'IBMid-1',
          isIBMer: true,
          isExpired: false,
          trialDays: 324,
          team_directory_enabled: true,
          hasLinkedSoftLayerAccount: false,
          linkages: [{
            origin: 'IMS',
            state: 'LINKABLE'
          }],
          billingCountryCode: 'USA',
          countryCode: 'USA',
          currencyCode: 'USD',
          userGuid: 'IBMid-1',
          iamUserId: 'IBMid-1',
          onboardState: 1,
          regions: [{
            name: 'us-south',
            orgs: ['123'],
            id: 'us-south'
          }],
          billing_system: 'DSW'
        }],
        selectedAccountGuid: '123',
        account: {
          status: 'ACTIVE',
          type: 'TRIAL',
          accountGuid: '123',
          accountName: "PAL's Account",
          isAccountOwner: true,
          owner: '12345',
          iamOwnerId: 'IBMid-1',
          isIBMer: true,
          isExpired: false,
          trialDays: 324,
          team_directory_enabled: true,
          hasLinkedSoftLayerAccount: false,
          linkages: [{
            origin: 'IMS',
            state: 'LINKABLE'
          }],
          billingCountryCode: 'USA',
          countryCode: 'USA',
          currencyCode: 'USD',
          userGuid: 'IBMid-1',
          iamUserId: 'IBMid-1',
          onboardState: 1,
          regions: [{
            name: 'us-south',
            orgs: ['123'],
            id: 'us-south'
          }],
          billing_system: 'DSW'
        }
      });
    }
    if (window.header) {
      // Set initial account state
      window.header.whenAccountReady(function (initAccount) {
        return setAccount(initAccount);
      });
    }
    var handleAccountChange = function handleAccountChange(_ref2) {
      var accountData = _ref2.detail.accountData;
      setAccount(accountData);
    };

    // Listen for updated account state (when a user changes the account in the common header)
    window.addEventListener('acctChanged', handleAccountChange);
    return function () {
      return window.removeEventListener('acctChanged', handleAccountChange);
    };
  }, [mock, mockObject]);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: account
  }, children);
};
Provider.propTypes = {
  children: PropTypes.node.isRequired,
  mock: PropTypes.bool,
  mockObject: PropTypes.shape({})
};
var useAccount = function useAccount() {
  return useContext(Context);
};
var Account = {
  Context: Context,
  Provider: Provider,
  useAccount: useAccount
};

export { Account as default };
